module.exports = __webpack_public_path__ + "static/media/ev-catalog-screenshot.a4fdf354.png";